import React from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
import { faker } from "@faker-js/faker";
import { Box, Paper, Skeleton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { WHITE, IRIS_60 } from "../../colors";
import { DateTime } from "luxon";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const CustomPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: WHITE,
  paddingTop: 15,
  paddingBottom: 10,
  paddingLeft: 15,
  height: 400,
  paddingRight: 15,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
  borderRadius: 10,
  minWidth: 570,
}));

const getDay = (date) => {
  const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const d = new Date(date);
  return weekday[d.getDay()];
};

export default function NewApplication(props) {
  const lenOnDay = (customers, day) => {
    var res = [];
    customers?.forEach((c) => {
      let date1 = new Date(c.createdAt);
      date1.setHours(0, 0, 0, 0);
      let date2 = new Date(day);
      date2.setHours(0, 0, 0, 0);
      if (date1.valueOf() === date2.valueOf()) {
        res.push(c);
      }
    });

    return res.length;
  };

  var f = { month: "long", day: "numeric", year: "numeric" };
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: `${DateTime.now().minus({ days: 6 }).setLocale("en-US").toLocaleString(f)} - ${DateTime.now()
          .setLocale("en-US")
          .toLocaleString(f)}`,
      },
    },
  };
  const days = [
    {
      label: getDay(DateTime.now().minus({ days: 6 }).toString()),
      data: lenOnDay(props.people, DateTime.now().minus({ days: 6 }).toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: getDay(DateTime.now().minus({ days: 5 }).toString()),
      data: lenOnDay(props.people, DateTime.now().minus({ days: 5 }).toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: getDay(DateTime.now().minus({ days: 4 }).toString()),
      data: lenOnDay(props.people, DateTime.now().minus({ days: 4 }).toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: getDay(DateTime.now().minus({ days: 3 }).toString()),
      data: lenOnDay(props.people, DateTime.now().minus({ days: 3 }).toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: getDay(DateTime.now().minus({ days: 2 }).toString()),
      data: lenOnDay(props.people, DateTime.now().minus({ days: 2 }).toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: getDay(DateTime.now().minus({ days: 1 }).toString()),
      data: lenOnDay(props.people, DateTime.now().minus({ days: 1 }).toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: getDay(DateTime.now().toString()),
      data: lenOnDay(props.people, DateTime.now().toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
  ];
  const data = {
    labels: days?.map((d) => d.label),
    datasets: [
      {
        label: "Number of new applications",
        data: days?.map((d) => d.data),
        backgroundColor: "#59A7FF",
      },
    ],
  };
  return (
    <CustomPaper>
      <Typography fontSize={18} color={IRIS_60} style={{ marginLeft: 25 }}>
        New Applications
      </Typography>

      {props.people && <Bar options={options} data={data} />}
      {!props.people && (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Skeleton variant="rectangular" width={430} height={330} />
        </Box>
      )}
    </CustomPaper>
  );
}
